import { render, staticRenderFns } from "./userForm.vue?vue&type=template&id=647c7b56&scoped=true&"
import script from "./userForm.vue?vue&type=script&lang=js&"
export * from "./userForm.vue?vue&type=script&lang=js&"
import style0 from "./userForm.vue?vue&type=style&index=0&id=647c7b56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647c7b56",
  null
  
)

export default component.exports